import React from "react";
import { Table, Placeholder } from "semantic-ui-react";

const PendingRow = ({ columnCount }) => {
  return (
    <Table.Row>
      {Array.from({ length: columnCount }).map((_value, index) => (
        <Table.Cell key={index}>
          <Placeholder fluid>&nbsp;</Placeholder>
        </Table.Cell>
      ))}
    </Table.Row>
  );
};

const PendingRowWithoutTable = () => {
  return (
    <div style={{ display: "flex" }}>
      <div style={{ width: "33.3%", margin: "8px" }}>
        <Placeholder style={{ maxWidth: "100%" }} />
      </div>
      <div style={{ width: "66.6%", margin: "8px" }}>
        <Placeholder style={{ maxWidth: "100%" }} />
      </div>
    </div>
  );
};

export { PendingRow, PendingRowWithoutTable };
